export const redListOfEcosystemCategory = [
  { label: 'Collapsed (CO)', value: 1 },
  { label: 'Critically Endangered (CR)', value: 2 },
  { label: 'Endangered (EN)', value: 3 },
  { label: 'Vulnerable (VU)', value: 4 },
  { label: 'Near Threatened (NT)', value: 5 },
  { label: 'Least Concern (LC)', value: 6 },
  { label: 'Data Deficient (DD)', value: 7 },
  { label: 'Not Evaluated (NE)', value: 8 }
]
